
// megamenu toggle logic
const headerMegaMenuParentEls = document.querySelectorAll('[data-mega-menu-for]');
const headerMegaMenuEls = document.querySelectorAll('.header-mega-menu_container');
const headerMenuNonMegaItems = document.querySelectorAll('.header-menu_desktop .header-menu_logo, .header-menu_desktop .header-menu_icons');

let removeAllActiveMegaMenus = () => {
    headerMegaMenuEls.forEach((el) => {
        el.classList.add('menu-hidden')
    })
}

headerMenuNonMegaItems.forEach((el) => {
    el.addEventListener('mouseenter', () => {
        removeAllActiveMegaMenus();
    })
})

headerMegaMenuParentEls.forEach((el) => {
    el.addEventListener('mouseenter', () => {
        removeAllActiveMegaMenus();
        // get the megamenu matched via the data attribute
        const megaMenuMatched = document.querySelector(`[data-title-for=${el.getAttribute('data-mega-menu-for')}]`);
        megaMenuMatched.classList.remove('menu-hidden');
    })
})
headerMegaMenuEls.forEach((el) => {
    el.addEventListener('mouseleave', () => {
        // get the megamenu matched via the data attribute
        el.classList.add('menu-hidden')
    })
})

// mobile menu logic

const mobileMenuParentItems = document.querySelectorAll('.header-menu-mobile_nav-items [data-link-menu-for]');
const mobileNavBackButtons = document.querySelectorAll('[data-mobile-nav-back-trigger]');

mobileMenuParentItems.forEach((parentItem) => {
    parentItem.addEventListener('click', (e) => {
        e.stopPropagation();
        parentItem.querySelector('.header-mobile-link-menu_container').classList.add('active');
    })
})

mobileNavBackButtons.forEach((button) => {
    button.addEventListener('click', (e) => {
        e.stopPropagation();
        button.closest('.header-mobile-link-menu_container').classList.remove('active')
    })
})

const mobileMenuContainer = document.querySelector('.header-menu-mobile--container')
const mobileMenuOpen = document.querySelector('[data-mobile-nav-trigger]')
const mobileMenuClose = document.querySelector('[data-mobile-nav-close]');

mobileMenuClose.addEventListener('click', () => {
    mobileMenuContainer.classList.remove('active');
    document.querySelector('.search-overlay').classList.remove('active');
    document.querySelector('.section-header.shopify-section-group-header-group').classList.remove('mobile--active');
})

mobileMenuOpen.addEventListener('click', () => {
    mobileMenuContainer.classList.add('active');
    document.querySelector('.search-overlay').classList.add('active');
    document.querySelector('.section-header.shopify-section-group-header-group').classList.add('mobile--active');
})
